import React from "react";
import {
  Avatar,
  Badge,
  Box,
  Center,
  Heading,
  SimpleGrid,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { getWorker } from "../../api/workers";
import LayoutView from "../../components/layout";
import Auth from "../../hoc/Auth";

const Detail = ({ label, value }) => (
  <Box p="4" bg="gray.50" borderRadius="xl">
    <Text fontSize="xs" textTransform="uppercase" letterSpacing="wide" color="gray.500" fontWeight="700">{label}</Text>
    <Text mt="1" fontWeight="700" color="gray.800">{value || "Not available"}</Text>
  </Box>
);

const Worker = () => {
  const workerId = useParams().id;
  const workerQuery = useQuery(
    ["getWorker", workerId],
    () => getWorker(workerId),
    { refetchInterval: 30 * 1000 },
  );
  const worker = workerQuery.data?.data;
  const isOnline = worker?.presence?.isOnline;

  return (
    <LayoutView activePage="Staff profile">
      <Box maxW="900px" mx="auto" bg="white" borderRadius="2xl" boxShadow="card" p={{ base: "5", md: "8" }}>
        {workerQuery.isLoading ? (
          <Center minH="300px"><Spinner color="brand.500" /></Center>
        ) : workerQuery.isError ? (
          <Center minH="300px" flexDirection="column">
            <Heading size="sm">Unable to load staff profile</Heading>
            <Text mt="2" color="gray.500">Please refresh and try again.</Text>
          </Center>
        ) : (
          <>
            <Center flexDirection="column" textAlign="center">
              <Avatar size="2xl" src={worker?.image} name={`${worker?.firstName || ""} ${worker?.lastName || ""}`} />
              <Heading mt="4" size="md">{worker?.firstName} {worker?.lastName}</Heading>
              <Text mt="1" color="gray.500">{worker?.unit} · {worker?.subUnit}</Text>
              <Badge mt="3" colorScheme={isOnline ? "green" : "gray"} borderRadius="full" px="3" py="1">
                {isOnline ? "Online now" : "Offline"}
              </Badge>
              {!isOnline && worker?.presence?.lastSeenAt && (
                <Text mt="2" fontSize="sm" color="gray.500">Last seen {new Date(worker.presence.lastSeenAt).toLocaleString()}</Text>
              )}
            </Center>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4" mt="8">
              <Detail label="Hospital ID" value={worker?.idNo} />
              <Detail label="Account status" value={worker?.status} />
              <Detail label="Email" value={worker?.email} />
              <Detail label="Phone number" value={worker?.phoneNumber} />
              <Detail label="Unit" value={worker?.unit} />
              <Detail label="Sub-unit" value={worker?.subUnit} />
              <Detail label="Room number" value={worker?.roomNumber} />
              <Detail label="Availability" value={worker?.available ? "Available" : "Unavailable"} />
              <Detail label="Last login" value={worker?.lastLogin ? new Date(worker.lastLogin).toLocaleString() : null} />
            </SimpleGrid>
          </>
        )}
      </Box>
    </LayoutView>
  );
};

export default Auth(Worker);
